/** Theme barrel — single import surface for all design tokens. */
export { colors, tone } from './colors';
export type { Colors, Tone } from './colors';
export { spacing } from './spacing';
export type { Spacing } from './spacing';
export { radii } from './radii';
export type { Radii } from './radii';
export { fontFamily, fontSize, fontWeight } from './typography';
export type { FontSize, FontWeight } from './typography';
export { shadows } from './shadows';
export type { Shadows } from './shadows';
export { motion, animClass } from './motion';
export type { Motion } from './motion';
